export const UserSearchIcon = () => {
  return (
    <svg
      width="54"
      height="54"
      viewBox="0 0 54 54"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="3" y="3" width="48" height="48" rx="24" fill="#99EAD6" />
      <rect
        x="3"
        y="3"
        width="48"
        height="48"
        rx="24"
        stroke="#CCF4EA"
        strokeWidth="5"
      />
      <path
        d="M25.009 25.75C27.353 25.75 29.259 23.843 29.259 21.5C29.259 19.157 27.353 17.25 25.009 17.25C22.665 17.25 20.759 19.157 20.759 21.5C20.759 23.843 22.665 25.75 25.009 25.75ZM25.009 18.75C26.526 18.75 27.759 19.983 27.759 21.5C27.759 23.017 26.526 24.25 25.009 24.25C23.492 24.25 22.259 23.017 22.259 21.5C22.259 19.983 23.492 18.75 25.009 18.75ZM27.881 28.8101C27.629 28.7691 27.341 28.75 27 28.75H23C19.057 28.75 18.75 32.019 18.75 33.02C18.75 34.583 19.423 35.25 21 35.25H26C26.414 35.25 26.75 35.586 26.75 36C26.75 36.414 26.414 36.75 26 36.75H21C18.582 36.75 17.25 35.425 17.25 33.02C17.25 30.358 18.756 27.25 23 27.25H27C27.421 27.25 27.787 27.276 28.119 27.33C28.528 27.395 28.807 27.78 28.74 28.189C28.675 28.598 28.28 28.8751 27.881 28.8101ZM37.53 36.47L35.699 34.639C36.15 33.983 36.417 33.19 36.417 32.334C36.417 30.083 34.585 28.251 32.333 28.251C30.082 28.251 28.25 30.083 28.25 32.334C28.25 34.585 30.082 36.417 32.333 36.417C33.188 36.417 33.9809 36.15 34.6379 35.699L36.469 37.531C36.615 37.677 36.807 37.751 36.999 37.751C37.191 37.751 37.3831 37.678 37.5291 37.531C37.8231 37.237 37.823 36.763 37.53 36.47ZM29.75 32.333C29.75 30.909 30.909 29.75 32.333 29.75C33.758 29.75 34.917 30.909 34.917 32.333C34.917 33.757 33.758 34.916 32.333 34.916C30.909 34.917 29.75 33.758 29.75 32.333Z"
        fill="#00795B"
      />
    </svg>
  );
};
